// ConfigContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchFromMaster } from "../services/MasterApi";

const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({});
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const data = await fetchFromMaster();
        setConfig(data);
      } catch (error) {
        console.error("Error fetching configuration:", error);
      }
    };
    fetchConfig();
    console.log(`Fetched Config!!!!! ${JSON.stringify(config)}`);
  }, []);
  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};

export const useConfig = () => {
  let config = useContext(ConfigContext);
  if (!config) {
    fetchFromMaster()
      .then((data) => {
        config = data;
        console.log(`Fetching Data from master ${config}`);
      })
      .catch((error) => {
        throw new Error("useConfig must be used within a ConfigProvider");
      });
  }
  return config;
};
